import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import type { ModuleDefinition } from '../../app/moduleRegistry';
import type { CurrentUser } from '../../api/types/auth';
import TravellerListPage from './pages/TravellerListPage';

/** Legacy "Kayıtlı Yolcu Listesi" — sidebar-gated to master GSA in the old app. */
const isVisible = (user: CurrentUser | null) => !!user?.isMasterGsa;

export const travellerModule: ModuleDefinition = {
  routes: [{ path: 'travellers', element: <TravellerListPage /> }],
  menuItems: [
    {
      label: 'Kayıtlı Yolcular',
      path: 'travellers',
      icon: <PeopleAltOutlinedIcon />,
      group: 'Sistem',
      isVisible,
    },
  ],
};
